var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "vote_edit",
    },
    [
      _c("label", [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$gettext(
                "Link eines Videos oder einer anderen Informationsseite (optional)"
              )
            ) +
            "\n        "
        ),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.val_clone.url,
              expression: "val_clone.url",
            },
          ],
          ref: "infoUrl",
          attrs: {
            type: "url",
          },
          domProps: {
            value: _vm.val_clone.url,
          },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.val_clone, "url", $event.target.value)
              },
              function ($event) {
                return _vm.checkValidity()
              },
            ],
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "formpart",
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$gettext("Hinweistext (optional)")) +
              "\n        "
          ),
          _c("StudipWysiwyg", {
            model: {
              value: _vm.val_clone.description,
              callback: function callback($$v) {
                _vm.$set(_vm.val_clone, "description", $$v)
              },
              expression: "val_clone.description",
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }